import type { NetSuiteConnectRequestPayload } from '@weft/api-definition';
import { NetSuiteConnectRequestSchema } from '@weft/api-definition';
import { useNetSuiteConnect } from 'apps/app/src/hooks/requests/use-net-suite';
import React from 'react';
import type { FormField } from './ConnectOAuthModal';
import { ConnectOAuthModal } from './ConnectOAuthModal';

export type ConnectNetSuiteModalProps = {
  open: boolean;
  onClose: () => void;
};

export const ConnectNetSuiteModal = ({ open, onClose }: ConnectNetSuiteModalProps): React.ReactElement => {
  const fields: FormField<NetSuiteConnectRequestPayload>[] = [
    { name: 'accountRealm', label: 'Account Realm' },
    { name: 'certificateId', label: 'Certificate ID' },
    { name: 'clientId', label: 'Client ID' },
  ];

  return (
    <ConnectOAuthModal
      open={open}
      onClose={onClose}
      fields={fields}
      schema={NetSuiteConnectRequestSchema}
      mutationHook={useNetSuiteConnect}
      dialogTitle="Connect NetSuite Account"
    />
  );
};